export default __webpack_public_path__ + "static/media/fad-logo-rackext.298adbd5.svg";